import {http} from '@/http'

export default {
  list()                { return http.get('/payroll-concepts') },
  listActive()          { return http.get('/payroll-concepts/active') },
  listActiveByType(type){ return http.get(`/payroll-concepts/active/${type}`) },
  get(id)               { return http.get(`/payroll-concepts/${id}`) },
  save(data)            { return http.post('/payroll-concepts', data) },
  update(id, data)      { return http.put(`/payroll-concepts/${id}`, data) },
  changeStatus(id, status) {
    return http.put(`/payroll-concepts/${id}/status`, null, { params: { status } })
  },
}
